import Filter from './Filter'

const $ = jQuery

class ButtonBarFilter extends Filter {
    buttons: JQuery[] = []
    noUnselect: boolean = true

    constructor(filterView: JQuery) {
        super()

        const initialValue = filterView.data('initial-value') || []
        this.value = initialValue

        this.type = filterView.data('type') || 'all'
        this.noUnselect = filterView.data('no-unselect') || false

        filterView.children().each((i, it) => {
            const button = $(it)
            if (initialValue.includes(button.data('value'))) {
                button.addClass('selected')
            }
            this.buttons.push(button)
            button.click(() => {
                if (button.hasClass('selected')) {
                    if (this.value.length === 1 && this.noUnselect) return
                    button.removeClass('selected')
                    this.value = this.value.filter(
                        (it) => it !== button.data('value'),
                    )
                } else {
                    if (this.type === 'one') {
                        this.value = []
                        for (const b of this.buttons) b.removeClass('selected')
                    }
                    button.addClass('selected')
                    this.value.push(button.data('value'))
                }
                this.onFilterChange()
            })
        })
    }

    reset() {
        super.reset()
        for (const button of this.buttons) {
            button.removeClass('selected')
        }
    }
}

export default ButtonBarFilter
